"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationProvider = void 0;
const React = __importStar(require("react"));
const Yup = __importStar(require("yup"));
const validation_messages_1 = require("./validation-messages");
function ValidationProvider({ children, }) {
    const msgs = validation_messages_1.useDefaultValidationMessages();
    React.useEffect(() => {
        Yup.setLocale({
            mixed: {
                required: msgs.requiredField,
            },
            number: {
                max: msgs.maxLength,
            },
        });
    }, [msgs]);
    return React.createElement(React.Fragment, null, children);
}
exports.ValidationProvider = ValidationProvider;
//# sourceMappingURL=validation-provider.js.map